import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { appTheme } from '../theme/colorTheme';
import Typography from '@mui/material/Typography';
import { getImgSrc } from '../constants/Helper';

const PaymentGatewayScreen = ({ data, handleChecked }) => {
    const [value, setValue] = React.useState(data[0].id);
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    React.useEffect(() => {
        handleChecked(data[0], true)  
    },[])
    return (
        <FormControl sx={{ color: appTheme.color1, paddingLeft: 2, width: '100%' }}>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={value}
                name="radio-buttons-group"
                onChange={handleChange}
            >
                {
                    data.map((item) => (
                        <FormControlLabel sx={{
                            border: +item.id === +value ? `1px solid ${appTheme.color12}` : `1px solid ${appTheme.color11}`,
                            width: '100%',
                            marginBottom: 1,
                            borderRadius: 2,
                        }}
                            onClick={() => handleChecked(item, true)}
                            key={item.id} value={item.id}
                            control={<Radio sx={{
                                color: appTheme.color11,
                                '&.Mui-checked': {
                                    color: appTheme.color12,
                                },
                            }} />} label={<>
                                <img
                                    src={!!getImgSrc(item?.logo_url) ? getImgSrc(item?.logo_url) : require('../img/no-pictures.png')}
                                    alt="gateway"
                                    style={{ width: 35, verticalAlign: 'middle', marginRight: 10, backgroundColor: appTheme.color1, borderRadius: 2, padding: 1 }} />
                                <Typography variant="caption" sx={{fontSize:8, verticalAlign: 'middle', backgroundColor: appTheme.color11, borderRadius: 2, padding: .5, paddingLeft: 1, paddingRight: 1 }}>
                                    Instant gateway
                                </Typography>
                            </>} />
                    ))
                }
            </RadioGroup>
        </FormControl>
    )
}
const PaymentGateway = React.memo(PaymentGatewayScreen);
export default PaymentGateway